export { default } from './rum-init';
